<template>
    <div>
        <template v-if="buttonOnly">
            <template v-if="exam.isUserPreRegistered">
                <div class="text-white mt-1 pt-2">You have already registered your interest in this exam.</div>
            </template>
            <template v-else>
                <b-button variant="primary" class="btn-slimpad btn-block btn-white btn-register-interest" @click="registerClick">Register interest</b-button>
            </template>
        </template>
        <template v-else>
            <div class="row justify-content-center">
                <div class="col-md-12">
                    <div class="block left">
                        <div class="row">
                            <div class="col-12 col-lg-8">
                                <h3 class="mb-2 mt-0">
                                    {{ exam.name }}
                                </h3>
                                <ul class="list-unstyled pl-0">
                                    <li>This assessment is not available yet.</li>
                                    <li>Sign up to our mailing list and be notified when this assessment is available.</li>
                                </ul>
                            </div>
                            <div class="col-12 col-lg-4 meta-col d-flex align-items-stretch">
                                <div class="meta-info no-border">
                                    <template v-if="exam.isUserPreRegistered">
                                        <div class="mt-3 text-center">
                                            <p class="mb-0">You have already registered your interest in this exam.</p>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <b-button variant="primary" class="btn-slimpad btn-block btn-white" @click="registerClick">Register interest</b-button>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <b-modal ref="registerModal" :title="'Pre-register for ' + exam.name" :ok-only="true" ok-variant="link" ok-title="Close">
            <template v-if="isAuth">
                <template v-if="isSuccess">
                    Thanks! You have registered your interest in this assessment. We will be in touch when this assessment is going on sale.
                </template>
                <template v-else>
                    <template v-if="isBusy">
                        Please wait...
                    </template>
                    <template v-else>
                        <b-alert variant="danger" :show="hasError" class="mb-2">{{ error }}</b-alert>
                        <b-button variant="success" @click="handlePreReg" :disabled="isBusy">Register interest</b-button>
                    </template>
                </template>
            </template>
            <template v-else>
                <p>
                    You're one step from registering your interest.  We just need a name, email and password.
                    You'll use your free account with us to take part in the assessment.
                </p>
                <auth-basic-component :exam="exam"></auth-basic-component>
            </template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            exam: {
                type: Object,
                required: true,
            },
            buttonOnly: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        data() {
            return {
                isAuth: false,
                user: {},
                isNewUser: false,
                isBusy: false,
                hasError: false,
                error: '',
                isSuccess: false,
            }
        },

        mounted() {
            console.log(this.exam);

            // User logged in?
            if(window.virtuoso) {
                if(window.virtuoso.is_auth) {
                    this.isAuth = true;
                    this.user = window.virtuoso.user;
                }
            }

            // When payment methods have been updated refresh that section
            Bus.$on("userRegistered", (d) => {
                this.isAuth = true;
                this.user = d;
                this.isNewUser = true;
                this.handlePreReg();
            });
        },

        methods: {
            // Clicked to apply for a seat
            registerClick() {
                this.$refs['registerModal'].show('registerModal');

                // Fire it immediately to stop using having to click again
                if(this.isAuth) {
                    this.beginPreReg();
                }
            },

            // Register them
            handlePreReg() {
                this.isBusy = true;
                axios.post('/api/exam/' + this.exam.id + '/pre-register')
                    .then((response) => {
                        if(response.data.success) {
                            this.isSuccess = true;
                        }

                        if(response.data.error) {
                            this.hasError = true;
                            this.error = response.data.error;
                        }
                    })
                    .catch((error) => {
                        this.hasError = true;
                        this.error = 'An unexpected error occurred.';
                    });
            },
        }
    }
</script>
